module.exports = __webpack_public_path__ + "img/trends_17.561a6f50.jpg";